"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlexStyleForColumn = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFlexStyleForColumn = function getFlexStyleForColumn(column) {
  var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var flexBasis = "".concat(column.props.width, "px");

  var style = _objectSpread(_objectSpread({}, customStyle), {}, {
    flexBasis: flexBasis,
    msFlexBasis: flexBasis,
    WebkitFlexBasis: flexBasis
  });

  if (column.props.maxWidth) {
    style.maxWidth = column.props.maxWidth;
  }

  if (column.props.minWidth) {
    style.minWidth = column.props.minWidth;
  }

  return style;
};

exports.getFlexStyleForColumn = getFlexStyleForColumn;

var ColumnRenderer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ColumnRenderer, _React$PureComponent);

  var _super = _createSuper(ColumnRenderer);

  function ColumnRenderer() {
    _classCallCheck(this, ColumnRenderer);

    return _super.apply(this, arguments);
  }

  _createClass(ColumnRenderer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          cellCache = _this$props.cellCache,
          column = _this$props.column,
          columnIndex = _this$props.columnIndex,
          parent = _this$props.parent,
          rowData = _this$props.rowData,
          rowIndex = _this$props.rowIndex;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          CellRenderer = _column$props.cellRenderer,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          style = _column$props.style;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var flexStyles = getFlexStyleForColumn(column, style);

      var columnStyle = _objectSpread({
        overflow: 'hidden'
      }, flexStyles);

      var columnClass = className;

      if (column.props.className) {
        columnClass += " ".concat(column.props.className);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: columnClass,
        style: columnStyle,
        key: "".concat(rowIndex, "-").concat(columnIndex)
      }, /*#__PURE__*/_react["default"].createElement(CellRenderer, {
        cellData: cellData,
        cellDataKey: dataKey,
        cellCache: cellCache,
        columnData: columnData,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      }));
    }
  }]);

  return ColumnRenderer;
}(_react["default"].PureComponent);

ColumnRenderer.propTypes = {
  className: _propTypes["default"].string,
  cellCache: _propTypes["default"].instanceOf(_reactVirtualized.CellMeasurerCache),
  column: _propTypes["default"].element.isRequired,
  columnIndex: _propTypes["default"].number.isRequired,
  parent: _propTypes["default"].instanceOf(_reactVirtualized.Grid),
  rowData: _propTypes["default"].shape({}).isRequired,
  rowIndex: _propTypes["default"].number.isRequired,
  style: _propTypes["default"].shape({})
};
ColumnRenderer.defaultProps = {
  className: 'nic-table-column',
  cellCache: null,
  style: {},
  parent: null
};
var _default = ColumnRenderer;
exports["default"] = _default;